export const LOCALE_CHANGE = 'LOCALE_CHANGE';

export const LOCALE_MATCHER_CHANGE = 'LOCALE_MATCHER_CHANGE';

export const NUMERIC_CHANGE = 'NUMERIC_CHANGE';

export const STYLE_CHANGE = 'STYLE_CHANGE';

export const RESET = 'RESET';
